'use strict';

var StrategyClosureActionsController = function StrategyClosureActionsController($scope) {
  $scope.integerWarning = 'The value must be an integer';
  $scope.clearInvalid = function (evt) {
    var el = evt.currentTarget;
    if (!el.validity.valid) {
      this.action[el.name] = null;
    }
  };
};
StrategyClosureActionsController.$inject = ['$scope'];
module.exports = StrategyClosureActionsController;